import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/components/Home'
// import HomeTest from '@/components/HomeTest'
// import Page from '@/components/Page'
// import Report from '@/components/Report'
import Special from '@/components/Special'

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Home', // 2023播报
    //   component: Home
    // },
    // {
    //   path: '/',
    //   name: 'Report',
    //   component: Report
    // },
    // {
    //   path: '/',
    //   name: 'HomeTest',
    //   component: HomeTest
    // },
    {
      path: '/',
      name: 'Special', // 2023专题
      component: Special
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js